import 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { jsxs, jsx } from 'react/jsx-runtime';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

var themes = ['light', 'dark'];

var _excluded = ["id", "className", "label", "message", "disabled", "theme"];
var classPrefix = 'forno-toggle';
/**
 * Renders a `<Toggle />` component
 * @param {Object} props
 * @param {string} [props.id] - The id of the toggle
 * @param {string} [props.className] - Custom class name
 * @param {string} [props.label] - Label text
 * @param {string} [props.message] - Message text
 * @param {string} [props.theme] - Theme name
 * @param {boolean} [props.checked] - Initial value
 * @param {boolean} [props.disabled] - Disabled state
 */

function Toggle(_ref) {
  var id = _ref.id,
      className = _ref.className,
      label = _ref.label,
      message = _ref.message,
      disabled = _ref.disabled,
      theme = _ref.theme,
      rest = _objectWithoutProperties(_ref, _excluded);

  var customClassName = classnames(classPrefix, className);
  var customLabelClassName = classnames("".concat(classPrefix, "-label"), 'font-block-m-sb', className);
  var customParagraphClassName = classnames("".concat(classPrefix, "-message"), 'font-paragraph-s', className);
  return /*#__PURE__*/jsxs("div", {
    "data-testid": "Toggle",
    className: customClassName,
    "data-with-message": !!message,
    "data-with-label": !!label,
    "data-theme": theme,
    "data-disabled": disabled,
    children: [label && /*#__PURE__*/jsx("p", {
      className: customLabelClassName,
      children: label
    }), /*#__PURE__*/jsxs("div", {
      className: "".concat(classPrefix, "-switch-wrapper"),
      children: [/*#__PURE__*/jsx("input", _objectSpread2({
        id: id,
        "data-testid": "Toggle-input",
        type: "checkbox",
        className: "".concat(classPrefix, "-checkbox"),
        disabled: disabled
      }, rest)), /*#__PURE__*/jsx("label", {
        htmlFor: id,
        className: "".concat(classPrefix, "-switch"),
        children: null
      })]
    }), message ? /*#__PURE__*/jsx("p", {
      className: customParagraphClassName,
      children: message
    }) : null]
  });
}
Toggle.propTypes = {
  id: PropTypes.string.isRequired,
  className: PropTypes.string,
  label: PropTypes.string,
  message: PropTypes.string,
  theme: PropTypes.oneOf(themes),
  disabled: PropTypes.bool
};
Toggle.defaultProps = {
  className: null,
  label: null,
  message: null,
  theme: 'light',
  disabled: false
};

export { Toggle as default };
